var _rect, _mask, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#1E232C",
    stroke: "#1E232C",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 20,
    width: 4,
    height: 2,
    rx: 1
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1661_261873",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C8.68629 3 6 5.68629 6 9V10.4453C6 10.5632 5.95659 10.6765 5.88071 10.7667L5.03338 11.7729C4.36599 12.5654 4 13.5682 4 14.6043C4 17.032 5.96803 19 8.39571 19H15.6043C18.032 19 20 17.032 20 14.6043C20 13.5682 19.634 12.5654 18.9666 11.7729L18.1193 10.7667C18.0434 10.6765 18 10.5632 18 10.4453V9C18 5.68629 15.3137 3 12 3Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03338 11.7729L6.18075 12.7391H6.18075L5.03338 11.7729ZM18.9666 11.7729L20.114 10.8067V10.8067L18.9666 11.7729ZM7.5 9C7.5 6.51472 9.51472 4.5 12 4.5V1.5C7.85786 1.5 4.5 4.85786 4.5 9H7.5ZM7.5 10.4453V9H4.5V10.4453H7.5ZM6.18075 12.7391L7.02808 11.7329L4.73334 9.80045L3.88601 10.8067L6.18075 12.7391ZM5.5 14.6043C5.5 13.9218 5.7411 13.2611 6.18075 12.7391L3.88601 10.8067C2.99088 11.8696 2.5 13.2146 2.5 14.6043H5.5ZM8.39571 17.5C6.79645 17.5 5.5 16.2035 5.5 14.6043H2.5C2.5 17.8604 5.1396 20.5 8.39571 20.5V17.5ZM15.6043 17.5H8.39571V20.5H15.6043V17.5ZM18.5 14.6043C18.5 16.2035 17.2035 17.5 15.6043 17.5V20.5C18.8604 20.5 21.5 17.8604 21.5 14.6043H18.5ZM17.8193 12.7391C18.2589 13.2611 18.5 13.9218 18.5 14.6043H21.5C21.5 13.2146 21.0091 11.8696 20.114 10.8067L17.8193 12.7391ZM16.9719 11.7329L17.8193 12.7391L20.114 10.8067L19.2667 9.80045L16.9719 11.7329ZM16.5 9V10.4453H19.5V9H16.5ZM12 4.5C14.4853 4.5 16.5 6.51472 16.5 9H19.5C19.5 4.85786 16.1421 1.5 12 1.5V4.5ZM19.2667 9.80045C19.4072 9.96731 19.5 10.1924 19.5 10.4453H16.5C16.5 10.9339 16.6796 11.3858 16.9719 11.7329L19.2667 9.80045ZM4.5 10.4453C4.5 10.1924 4.59283 9.96731 4.73334 9.80045L7.02808 11.7329C7.32036 11.3858 7.5 10.9339 7.5 10.4453H4.5Z",
    mask: "url(#path-2-inside-1_1661_261873)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 2,
    height: 2,
    rx: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.a24a29d5b05f74b40acb821f36900154.svg";
export { ForwardRef as ReactComponent };